













































































import Vue from "vue";
import { createNamespacedHelpers } from "vuex";
import { FAQCategory, Business, Role } from "@/types";

const { mapActions: categoryActions } =
  createNamespacedHelpers("FAQ_CATEGORY_");

interface VForm extends Vue {
  validate(): boolean;
  reset(): void;
}

export default Vue.extend({
  name: "FAQCategoryForm",
  props: {
    category: {
      type: Object as () => FAQCategory | null,
      default: null,
    },
  },
  data() {
    return {
      valid: false,
      loading: false,
      formData: {
        name: "",
        description: "",
        order: 1,
      },
      nameRules: [
        (v: string) => !!v || "Name is required",
        (v: string) =>
          (v && v.length <= 50) || "Name must be less than 50 characters",
      ],
    };
  },
  computed: {
    role(): Role {
      return this.$store.getters.role;
    },
    isEdit(): boolean {
      return !!this.category;
    },
  },
  methods: {
    ...categoryActions(["createCategory", "updateCategory"]),
    resetForm() {
      if (this.$refs.form) {
        (this.$refs.form as VForm).reset();
      }
      this.formData = {
        name: "",
        description: "",
        order: 1,
      };
    },
    populateForm() {
      if (this.category) {
        this.formData = {
          name: this.category.name || "",
          description: this.category.description || "",
          order: this.category.order || 1,
        };
      }
    },
    async submitForm() {
      if (this.$refs.form) {
        if (!(this.$refs.form as VForm).validate()) {
          return;
        }
      }

      this.loading = true;

      try {
        if (this.role) {
          // Get the business ID - updated to match the API structure
          const businessId =
            typeof this.role.business === "string"
              ? this.role.business
              : (this.role.business as Business)._id;

          // Create payload with business property
          const payload = {
            ...this.formData,
            business: businessId,
          };

          console.log("FAQ Category payload:", payload);

          if (this.isEdit && this.category) {
            await this.updateCategory({
              id: this.category._id,
              category: payload,
            });
          } else {
            await this.createCategory(payload);
          }

          this.$emit("refresh");
          this.$emit("close");
        }
      } catch (error) {
        console.error("Error submitting form:", error);

        // Show error notification
        this.$store.dispatch("setToast", {
          title: "Error",
          type: "error",
          text: "Failed to save FAQ category. Please try again.",
        });
      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    this.populateForm();
  },
  watch: {
    category: {
      handler() {
        this.populateForm();
      },
      deep: true,
    },
  },
});
